import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

function* removeGroupUsers({ payload: { id, values, onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.modifiers.regularusers.removeUsers, id, data: values });

    onSuccess && onSuccess(data.result);
    yield put(actions.removeGroupUsersDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.removeGroupUsersFailed,
      handledErrors,
      endpoint: api.modifiers.regularusers.removeUsers.url
    });
  }
}

export const removeGroupUsersSaga = takeEvery(types.REMOVE_GROUP_USERS_REQUEST, removeGroupUsers);